import { React } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const SecondValidMemberInfo = (props) => {
  const { data, isOver, onClick } = props;
  
  return (
    <TopLevelWrapper isOver={isOver} onClick={onClick}>
      {
        isOver ?
          <Table>
            <Body isOver={isOver}>
              <Tr>
                <Td style={{ width: 'max(98px, 10.7vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(98px, 10.7vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.startDate.split('T')[0].replaceAll('-', '.')}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(98px, 10.6vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(98px, 10.6vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.endDate.split('T')[0].replaceAll('-', '.')}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(197px, 24vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(197px, 24vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.categoryName}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(24px, 3.125vw)', marginRight: `270px` }}>
                  <TextWrapper style={{ maxWidth: 'max(24px, 3.125vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.count}</Text>
                  </TextWrapper>
                </Td>
                {
                  moment(data.endDate).diff(moment(), 'day') <= 5 &&
                  <Td>
                    <TextWrapper style={{ maxWidth: '45px' }}>
                      <Dday>{moment(data.endDate).diff(moment(), 'day') === 0 ? 'D-day' : 'D-' + moment(data.endDate).diff(moment(), 'day')}</Dday>
                    </TextWrapper>
                  </Td>
                }
              </Tr>
            </Body>
          </Table>
          :
          <Table>
            <Body isOver={isOver}>
              <Tr>
                <Td style={{ width: 'max(57px, 15.9vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(57px, 15.9vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.startDate.split('T')[0].replaceAll('-', '.')}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(57px, 16vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(57px, 16vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.endDate.split('T')[0].replaceAll('-', '.')}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(56px, 15.6vw)' }}>
                  <TextWrapper style={{ maxWidth: 'max(56px, 15.6vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.categoryName}</Text>
                  </TextWrapper>
                </Td>
                <Td style={{ width: 'max(37px, 11.5625vw)', marginRight: `50px` }}>
                  <TextWrapper style={{ maxWidth: 'max(37px, 11.5625vw)' }} isOver={isOver}>
                    <Text isOver={isOver}>{data.count}</Text>
                  </TextWrapper>
                </Td>
                {
                  moment(data.endDate).diff(moment(), 'day') <= 5 &&
                  <Td>
                    <TextWrapper style={{ maxWidth: '45px' }}>
                      <Dday>{moment(data.endDate).diff(moment(), 'day') === 0 ? 'D-day' : 'D-' + moment(data.endDate).diff(moment(), 'day')}</Dday>
                    </TextWrapper>
                  </Td>
                }
              </Tr>
            </Body>
          </Table>
      }
    </TopLevelWrapper>
  )
};

export default SecondValidMemberInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: ${props => props.isOver ? `max(690px, 89.84375vw)` : `max(281px, 87.8125vw)`};
  height: ${props => props.isOver ? `50px` : `17px`};

  background: #FFFFFF;

  margin-top: ${props => props.isOver ? `8px` : `4px`};

  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  border: 1px solid #FFFFFF;
  border-radius: 30px;
  
  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    border: 1px solid #FF8B48;
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
  
  margin-left: ${props => props.isOver ? `max(28px, 3.645833333333333vw)` : `max(10px, 3.125vw)`};
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  padding: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: ${props => props.isOver ? `20px` : `15px`};
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: #595959;

  margin: 0 0 0 0;

  -webkit-transform: ${props => props.isOver ? `scale(1)` : `scale(0.9)`};
`;

const Dday = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 100%;

  border-radius: 30px;
  background-color: #FF8B48;

  font-family: NotoSansKR-Regular;
  font-size: 11px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;